<script setup>
import { onMounted } from 'vue';
import { EventManager, Actions, Events } from "@events";
import { useVideoCallState } from "@/stores/videoCallState";
import Swal from "sweetalert2";
import i18n from "@/i18n";
import configurationProvider from "@/Core/configurationProvider";

const props = defineProps({
    rtcId: {
        type: String,
        required: true,
    }
});

const state = useVideoCallState(props.rtcId);
let eventEmitter = null;
let actionEmitter = null

onMounted(async () => {
    if(state.role == "agent"){
        eventEmitter = EventManager.getEventEmitter(props.rtcId);
        actionEmitter = EventManager.getActionEmitter(props.rtcId);
        let timerInterval;

        eventEmitter.addListener(Events.VideoMuted, async (event) => {
            if(typeof state.isHeld == 'boolean' && !state.isHeld){
                actionEmitter.emit(Actions.SendTextChannelMessage, {
                    message: `HOLD|${props.rtcId}`,
                });

                actionEmitter.emit(Actions.MuteAudio);

                Swal.fire({
                    title: i18n.global.t("AudioVideoWillBeEnabledAfter"),
                    timer: configurationProvider.getInt("VIDEO_AUTO_UNMUTE_DURATION", 7) * 1000,
                    timerProgressBar: true,
                    allowOutsideClick: false,
                    showCancelButton: false,
                    confirmButtonColor: "#3085d6",
                    background: "#363535",
                    color: "#ffffff",
                    confirmButtonText: i18n.global.t("EnableAudioVideo"),
                    didOpen: () => {
                        const timer = Swal.getPopup().querySelector("b");
                        timer.textContent = Math.ceil(Swal.getTimerLeft() / 1000);
                        timerInterval = setInterval(() => {
                            timer.textContent = Math.ceil(Swal.getTimerLeft() / 1000);
                        }, 500);
                    },
                    willClose: () => {
                        clearInterval(timerInterval);
                        timerInterval = undefined;
                    }
                }).then((result) => {
                    if(result) actionEmitter.emit(Actions.UnmuteVideo);
                    if(typeof state.isHeld == 'boolean' && state.isHeld){
                        state.setIsHeld(false);
                    }
                });
            }
        });

        eventEmitter.addListener(Events.VideoUnmuted, async (event) => {
            actionEmitter.emit(Actions.SendTextChannelMessage, {
                message: `PICKUP|${props.rtcId}`,
            });

            actionEmitter.emit(Actions.UnmuteAudio);

            clearInterval(timerInterval);
            timerInterval = undefined;
            if(Swal.isVisible()){
                Swal.close();
            }
        });
    }
});
</script>

<template></template>